import {Routes} from '@angular/router';
import {
  redirectFirstVisitToLanding
} from './landing/first-visit-landing.guard';

export const routes: Routes = [
  {
    path: 'landing',
    loadChildren: () =>
      import('./landing/landing.routes')
        .then(m => m.landingRoutes),
  },
  {
    // Top-level so it bypasses the tabs shell and
    // redirectFirstVisitToLanding, and isn't swallowed by the
    // prefix-matching '' branch below.
    path: 'onboarding',
    loadChildren: () =>
      import('./onboarding/onboarding.routes')
        .then(m => m.onboardingRoutes),
  },
  {
    path: '',
    loadChildren: () =>
      import('./tabs/tabs.routes')
        .then(m => m.routes),
    canActivate: [redirectFirstVisitToLanding],
  },
];
